import { render } from "./ValidationPixKeyCpfCnpjForm.vue?vue&type=template&id=6d93e446"
import script from "./ValidationPixKeyCpfCnpjForm.vue?vue&type=script&lang=js"
export * from "./ValidationPixKeyCpfCnpjForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__